import React from 'react';
import {connect} from 'react-redux';
import {Dispatch} from '@Redux/type';
import {AppState} from '@Redux/store';
import {container} from "@Container";
import {MyFolderAction} from "@Redux/actions";
import {TYPES} from "@Types";
import {AddArmyListParams} from "./validate";
import {AddArmyListPresenter} from "@Selectors/builder/myFolder/addArmyList/AddArmyListPresenter";
import AddArmyListForm from "./AddArmyListForm";
import folderSlice from '@Redux/reducers/builder/folder.slice';

const FolderAddArmy: React.FC<FolderAddArmyProps> = ({datas, cancel, handleSubmit}) => {

  return (
    <div className="mt-2 text-center">
      <AddArmyListForm cancel={cancel} onSubmit={handleSubmit} canSubmit={datas.canSubmit}
                      armyLists={datas.armyLists}/>
    </div>
  );
};

const mapStateToProps = (state: AppState, props: any) => ({
  datas: AddArmyListPresenter(state, props)
});

const mapDispatchToProps = (dispatch: Dispatch) => {
  const action = container.get<MyFolderAction>(TYPES.Actions.MyFolderAction);

  return {
    handleSubmit: (values: AddArmyListParams) => dispatch(action.addArmyList(values.armyListId)),
    cancel: () => dispatch(folderSlice.actions.cancel())
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(FolderAddArmy);

type FolderAddArmyProps = ReturnType<typeof mapDispatchToProps> &
  ReturnType<typeof mapStateToProps>
